import { Controller } from "stimulus"
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  static values = {
    activeClass: String
  };

  connect() {
    let framesLink = this.element.querySelectorAll("[data-turbo-frame]")
    framesLink.forEach(($el) => {
      $el.addEventListener('click', async(ev) => {
        let turboFrame = document.querySelector(`turbo-frame#${$el.dataset.turboFrame}`);

        if (!turboFrame)
          return;

        AjaxLoader.show();
        framesLink.forEach((it) => it.classList.remove(this.activeClassValue));
        $el.classList.add(this.activeClassValue);
        turboFrame.classList.add('opacity-50');

        turboFrame.addEventListener('turbo:frame-load', function(ev) {
          turboFrame.classList.remove('opacity-50');
          AjaxLoader.hide();
        });
      });
    });
  }
}